import type { AppetiteParentRegisterResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetAppetitesByRiskIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetAppetitesByRiskIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import {
  createLazyQueryHook,
  type StrictMappedGraphQLSelection,
} from 'src/utils';

type UseLazyGetAppetitesByRiskIdArgs = {
  riskId: string;
};

/**
 * Maps TRPC appetite data to match the GraphQL query structure
 */
function mapTrpcAppetitesToGraphQL(
  trpcData: AppetiteParentRegisterResponseRow[]
): StrictMappedGraphQLSelection<GetAppetitesByRiskIdQuery> {
  return {
    appetite_parent: trpcData,
  };
}

export const useLazyGetAppetitesByRiskId = createLazyQueryHook<
  UseLazyGetAppetitesByRiskIdArgs,
  AppetiteParentRegisterResponseRow[],
  GetAppetitesByRiskIdQuery
>({
  trpcQuery: (client, { riskId }) =>
    client.frontend.appetite.appetitesByRiskId.query({ riskId }),
  mapTrpcDataToGraphQL: mapTrpcAppetitesToGraphQL,
  graphqlDocument: GetAppetitesByRiskIdDocument,
  graphqlVariables: ({ riskId }) => ({ riskId }),
});
